module.exports = __webpack_public_path__ + "static/media/impact-totalcoop.5a549c47.png";